import React from "react";
import type { ComponentType } from "react";
import { SidebarContext, SidebarContextProvider } from "./context";
import type { SidebarContextProviderProps } from "./context";
import type { SidebarContextValue } from "./types";

import * as ACTIONS from "./actionTypes";
export { ACTIONS };

// a helpful custom hook to easily use the forecast context
export const useSidebarContext = (): SidebarContextValue => {
  const context = React.useContext(SidebarContext);
  if (!context) {
    throw new Error(
      "useSidebarContext must be used within a SidebarContextProvider"
    );
  }
  return context;
};

// a helpful simple HOC to easily provide the context
export const withSidebarContextProvider = <P extends object>(
  WrappedComponent: ComponentType<P>
) => {
  return class extends React.Component<P & SidebarContextProviderProps> {
    override render() {
      return (
        <SidebarContextProvider {...this.props}>
          <WrappedComponent {...this.props} />
        </SidebarContextProvider>
      );
    }
  };
};
